<!-- eslint-disable prettier-vue/prettier -->
<template>
  <div>
    <v-card
      elevation="0"
      class="service-card"
      :class="{
        selected: serviceSelected,
        subscribed: serviceSubscribed,
        renew: serviceNeedsRenew
      }
      "
      :disabled="serviceInCart && serviceInCart.length > 0"
    >
      <div class="service-card-header">
        <v-img
          v-if="service.iconUrl"
          :src="service.iconUrl"
          width="30"
          class="service-card-icon"
        />
        <h2>{{ service.name }}</h2>
        <v-menu
          v-if="shouldShowOptionsMenu"
          offset-x
          right
          bottom
          class="service-card-options"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              icon
              class="service-card-options-btn"
              v-on="on"
            >
              <v-img
                v-if="servicesDaysToExpire"
                :src="$t('vehicle_details.img.options_subscribed.img')"
                width="16"
              />
              <v-img
                v-else
                :src="$t('vehicle_details.img.options_renew.img')"
                width="16"
              />
            </v-btn>
          </template>

          <v-list
            dense
            style="padding:0"
            class="elevation-2"
          >
            <v-list-item-group color="primary">
              <v-list-item
                :disabled="serviceStatus === 'Remove'"
              >
                <v-list-item-title
                  class="list-item-stop-service"
                  @click="handleStopService(service, vehicle)"
                >
                  {{ $t('vehicle_details.txt.stop_service') }}
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>
      <div class="service-card-description">
        <div v-if="shouldShowExpirationDate && correctExpirationDate">
          <span>{{ $t('vehicle_details.txt.active_until') }}</span>
          <p
            v-if="correctExpirationDate"
            class="text-left"
          >
            <strong>
              {{ correctExpirationDate | formatDate }}
              <!-- ({{ formattedTimeToExpire.value }} {{ $t(formattedTimeToExpire.unit) }}) -->
            </strong>
            <span class="subscription-period-badge">({{ service.daysToExpire }} {{ $t('days') }})</span>
            <!-- <span
              v-if="service.periodName"
              class="subscription-period-badge"
            >
              {{ service.periodName }}
            </span> -->
          </p>
        </div>
        <div>
          <div
            v-if="service.description"
            class="card-description"
          >
            <div
              style="display:inline"
            >
              {{ service.descriptionShort }} ...
            </div>

            <a
              class="card-description-more"
              @click="activateReadMore()"
            >
              {{ $t('vehicle_details.txt.more') }}
            </a>
            <v-dialog
              v-model="isDialogVisible"
              max-width="600"
              content-class="more-dialog"
              @click="isDialogVisible = !isDialogVisible"
            >
              <v-card class="dialog-card">
                <div class="dialog-card-header">
                  <v-img
                    v-if="service.iconUrl"
                    :src="service.iconUrl"
                    width="30"
                    class="dialog-card-header-icon"
                  />
                  <h2>{{ service.name }}</h2>
                  <v-btn
                    icon
                    class="dialog-card-header-close"
                    @click="
                      isDialogVisible = !isDialogVisible
                    "
                  >
                    <v-icon
                      width="18"
                      color="reddish"
                    >
                      mdi-close
                    </v-icon>
                  </v-btn>
                </div>
                <div class="dialog-card-content">
                  <div>{{ service.description }}</div>
                </div>
                <div
                  v-if="service.subscriptionLevel==='Truck' &&
                    isSubscribable && canSelectPeriod && serviceRatePlan"
                  class="dialog-card-footer"
                >
                  <span
                    v-if="!service.subscribed"
                    class="pl-1"
                  >{{ $t('vehicle_details.txt.select_subscription') }}</span>
                  <span
                    v-else-if="vehicle.autoRenew && serviceStatus !== 'Remove' && !isDafConnectExtendAllowed"
                    class="pl-1"
                  >{{ $t('vehicle_details.txt.prices') }}</span>
                  <span
                    v-else
                    class="pl-1"
                  >{{ $t('vehicle_details.txt.renew_subscription') }}</span>
                  <v-btn-toggle
                    group
                    dense
                    class="dialog-card-footer-buttons"
                    @change="setPeriod"
                  >
                    <v-btn
                      v-if="service.showMonthlyPrice && !extendingUnsubscribable('month')"
                      v-model="selectedItems[service.productRatePlanIdMonthly]"
                      active-class="active"
                      :disabled="(!isDafConnectExtendAllowed && vehicle.autoRenew && service.daysToExpire <= DAYS_BEFORE_EXPIRY_IMMINENT_RENEWAL && serviceStatus !== 'Remove') || (!vehicle.hasBaseProduct && service.category !== 'Base Products') || !billingPeriodMonth || (!isDafConnectExtendAllowed && period === 'year')"
                      value="month"
                      @click="sendItems()"
                    >
                      {{ service.monthlyCost | formatPrice(currency.symbol) }} <small>{{ $t('vehicle_details.txt.month') }}</small>
                    </v-btn>
                    <v-btn
                      v-if="service.showAnnualPrice && !extendingUnsubscribable('annual') && !isDafConnectExtendAllowed"
                      v-model="selectedItems[service.productRatePlanIdYearly]"
                      active-class="active"
                      :disabled="(!isDafConnectExtendAllowed && vehicle.autoRenew && service.daysToExpire <= DAYS_BEFORE_EXPIRY_NEAR_RENEWAL && serviceStatus !== 'Remove') || (!vehicle.hasBaseProduct && service.category !== 'Base Products') || !billingPeriodYear || period === 'month'"
                      value="year"
                      @click="sendItems()"
                    >
                      {{ service.yearlyCost | formatPrice(currency.symbol) }} <small>{{ $t('vehicle_details.txt.year') }}</small>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
      <div
        v-if="service.showMonthlyPrice || service.showAnnualPrice"
        class="service-card-subscription"
      >
        <div v-if="service.subscriptionLevel!=='Company'">
          <div v-if="isSubscribable && canSelectPeriod && serviceRatePlan">
            <span
              v-if="!service.subscribed"
              class="pl-1"
            >{{ $t('vehicle_details.txt.select_subscription') }}</span>
            <span
              v-else-if="vehicle.autoRenew && serviceStatus !== 'Remove' && !isDafConnectExtendAllowed"
              class="pl-1"
            >{{ $t('vehicle_details.txt.prices') }}</span>
            <span
              v-else
              class="pl-1"
            >{{ $t('vehicle_details.txt.renew_subscription') }}</span>
            <v-btn-toggle
              group
              dense
              class="service-card-subscription-buttons"
              @change="setPeriod"
            >
              <v-btn
                v-if="service.showMonthlyPrice && !extendingUnsubscribable('month')"
                v-model="selectedItems[service.productRatePlanIdMonthly]"
                active-class="active"
                :disabled="(!isDafConnectExtendAllowed && vehicle.autoRenew && service.daysToExpire <= DAYS_BEFORE_EXPIRY_NEAR_RENEWAL && serviceStatus !== 'Remove') || (!vehicle.hasBaseProduct && service.category !== 'Base Products') || !billingPeriodMonth || (!isDafConnectExtendAllowed && period === 'year') || appWithNoTablet"
                value="month"
                @click="sendItems()"
              >
                {{ service.monthlyCost | formatPrice(currency.symbol) }} <small>{{ $t('vehicle_details.txt.month') }}</small>
              </v-btn>

              <v-btn
                v-if="service.showAnnualPrice && !extendingUnsubscribable('annual') && !isDafConnectExtendAllowed"
                v-model="selectedItems[service.productRatePlanIdYearly]"
                active-class="active"
                :disabled="(!isDafConnectExtendAllowed && vehicle.autoRenew && service.daysToExpire <= DAYS_BEFORE_EXPIRY_NEAR_RENEWAL && serviceStatus !== 'Remove') || (!vehicle.hasBaseProduct && service.category !== 'Base Products') || !billingPeriodYear || period === 'month' || appWithNoTablet"
                value="year"
                @click="sendItems()"
              >
                {{ service.yearlyCost | formatPrice(currency.symbol) }} <small>{{ $t('vehicle_details.txt.year') }}</small>
              </v-btn>
            </v-btn-toggle>
          </div>
          <div
            v-else-if="isSubscribable"
            class="service-subscribed"
          >
            <v-icon
              width="16"
              color="peacock"
            >
              mdi-check
            </v-icon>
            <span>
              {{ $t('vehicle_details.txt.subscribed') }}
            </span>
          </div>
        </div>
        <div v-else>
          <div
            v-if="service.subscribed && service.daysToExpire > DAYS_BEFORE_EXPIRY_NEAR_RENEWAL"
            class="service-subscribed"
          >
            <v-icon
              width="16"
              color="peacock"
            >
              mdi-check
            </v-icon>
            <span>
              {{ $t('vehicle_details.txt.subscribed') }}
            </span>
          </div>
          <div
            v-else
            class="service-to-subscribe pl-0 ml-0"
          >
            <router-link
              v-if="!vehicle.autoRenew && (vehicle.hasBaseProduct || service.category==='Base Products')"
              class="enabled"
              :to="{ name: 'services'}"
            >
              {{ $t('vehicle_details.txt.subscribe') }}
            </router-link>
            <span
              v-else
              class="disabled"
            >
              {{ $t('vehicle_details.txt.subscribe') }}
            </span>
          </div>
        </div>
      </div>
      <div
        v-else-if="service.subscribed"
        class="service-card-longlived-subscribed"
      >
        <v-icon
          width="16"
          color="peacock"
        >
          mdi-check
        </v-icon>
        <span>
          {{ $t('vehicle_details.txt.subscribed') }}
        </span>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ProductType } from '@/helpers/enums'
import { canExtendAsMonthlyEssentials, isBaseProductSku } from '@/helpers/baseProducts'

// Constants for renewal periods
const DAYS_BEFORE_EXPIRY_NEAR_RENEWAL = 60
const DAYS_BEFORE_EXPIRY_IMMINENT_RENEWAL = 30

export default {
  name: 'VehicleDetailsCard',
  props: {
    service: {
      type: Object,
      required: true,
      validator: (val) => {
        return val.name && val.sku && typeof val.subscribed === 'boolean'
      }
    },
    vehicle: {
      type: Object,
      required: true,
      validator: (val) => {
        return val.subscription_number && typeof val.autoRenew === 'boolean'
      }
    },
    servicesAll: {
      type: Array,
      default: () => []
    },
    billingPeriodMonth: {
      type: Boolean,
      default: false
    },
    billingPeriodYear: {
      type: Boolean,
      default: false
    },
    period: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDialogVisible: false,
      selectedItems: {},
      // Constants (available in template)
      DAYS_BEFORE_EXPIRY_NEAR_RENEWAL,
      DAYS_BEFORE_EXPIRY_IMMINENT_RENEWAL
    }
  },
  computed: {
    ...mapState('account', ['currency', 'accountInformation']),
    ...mapState('checkout', ['checkout']),
    /**
     * Show Extend for legacy DAF Connect and for Portal Essentials TS 10-year
     * when fewer than 60 days remain. The option sold is Portal Essentials monthly.
     * Connect stays hidden when an Essentials variant is already active.
     */
    isDafConnectExtendAllowed() {
      return canExtendAsMonthlyEssentials(
        this.service?.sku,
        this.service?.daysToExpire,
        this.vehicle?.activeServices || [],
        DAYS_BEFORE_EXPIRY_NEAR_RENEWAL
      )
    },
    serviceSelected() {
      return (
        this.selectedItems[this.service.productRatePlanIdMonthly] ||
        this.selectedItems[this.service.productRatePlanIdYearly]
      )
    },
    serviceSubscribed() {
      return (
        (this.service.subscribed && this.service.daysToExpire > DAYS_BEFORE_EXPIRY_NEAR_RENEWAL) ||
        (this.service.subscribed && this.service.subscriptionLevel !== 'Truck')
      )
    },
    serviceNeedsRenew() {
      return this.service.daysToExpire <= DAYS_BEFORE_EXPIRY_NEAR_RENEWAL
    },
    servicesDaysToExpire() {
      return this.service.daysToExpire > DAYS_BEFORE_EXPIRY_NEAR_RENEWAL
    },
    canSelectPeriod() {
      return (
        !this.service.subscribed ||
        this.service.daysToExpire <= DAYS_BEFORE_EXPIRY_NEAR_RENEWAL ||
        this.serviceStatus === 'Remove'
      )
    },
    isSubscribable() {
      // DAF Connect exception: allow extending even if not "subscribable" per rateplan flags
      if (this.isDafConnectExtendAllowed) return true

      // below if condition is for Mobile Service to check if the base product is subscribed. Based on the base product subscription, addons are displayed for the purchase
      if (
        this.service.type__c === 'InVehicleApp' &&
        this.service.subscribable &&
        !this.service.subscribed &&
        !this.service.isBaseProduct
      ) {
        const getBaseProduct = this.servicesAll.filter(baseResult => {
          if (
            baseResult.isBaseProduct &&
            baseResult.type__c === 'InVehicleApp'
          ) {
            return true
          }
        })
        const getSubscribedBaseProduct = getBaseProduct.filter(
          subscribeResult => {
            if (subscribeResult.subscribed) {
              return true
            }
          }
        )
        if (getSubscribedBaseProduct.length > 0) {
          return true
        }
        return false
      }

      return this.service.subscribable
    },
    serviceRatePlan() {
      return this.service.rateplans && this.service.rateplans.length > 0
    },
    serviceInCart() {
      const array = []
      const x = this.checkout
        ? this.checkout.filter(x => x.productID === this.service.prodId)
        : false
      if (x && x.length > 0) {
        x.forEach(product => {
          product.rateplans.forEach(rp => {
            rp.subscriptions.forEach(sub => {
              if (sub.subscriptionID === this.vehicle.subscription_number) {
                array.push(rp)
              }
            })
          })
        })
      }
      return array
    },
    /**
     * Row in vehicle.activeServices that matches this card (charge id > rate plan + product > sku).
     */
    matchingActiveServiceRow() {
      const list = this.vehicle?.activeServices || []
      const chargeId = this.service.ratePlanChargeId
      if (chargeId) {
        const byCharge = list.find(
          s => (s.ratePlanChargeId ?? s.RatePlanChargeId) === chargeId
        )
        if (byCharge) return byCharge
      }
      const subRpId = this.service.subscriptionRatePlanId
      const pid = this.service.prodId
      if (subRpId && pid) {
        const byPlan = list.find(
          s =>
            (s.subscriptionRatePlanId ?? s.SubscriptionRatePlanId) === subRpId &&
            (s.productID ?? s.ProductID) === pid
        )
        if (byPlan) return byPlan
      }
      const sku = this.service.sku
      return list.find(s => (s.sku ?? s.Sku) === sku)
    },
    /**
     * Get flag canStop (true/false) from vehicle active services
     * Used to enable/disable "Stop service" options button
     */
    serviceCanStop() {
      const serv = this.matchingActiveServiceRow
      return !!(serv && this.service.subscribed === true && serv.canStop)
    },
    /**
     * Determines if the options menu (three dots) should be displayed
     * The menu is shown when:
     * - Service is subscribed
     * - Service is not an R&M product
     * - API activeServices row has canStop === true (see serviceCanStop)
     *
     * Important: do not require stoppableByWebshopUser — the backend may leave that
     * field empty and still set canStop via fallback (e.g. !IsRMProduct).
     */
    shouldShowOptionsMenu() {
      return (
        this.service.subscribed &&
        !this.service.isRMProduct &&
        this.serviceCanStop
      )
    },
    serviceCantStopHealth() {
      const skuHealth = this.vehicle.activeServices.find(
        x => (x.sku ?? x.Sku) === 'DAF-VHT-001'
      )
      return !!(skuHealth && (skuHealth.sku ?? skuHealth.Sku) != null)
    },
    serviceCantStopEssentials() {
      const skuDep = this.vehicle.activeServices.find(
        x => isBaseProductSku(x.sku ?? x.Sku)
      )
      return !!(skuDep && (skuDep.sku ?? skuDep.Sku) != null)
    },
    serviceStatus() {
      return this.matchingActiveServiceRow?.status
    },
    appWithNoTablet() {
      return (
        !this.vehicle.hasTablet &&
        this.service.type__c === ProductType.InVehicleApp
      )
    },
    /**
     * Get the subscription period display text (Monthly, Annual, 5 Years, etc.)
     */
    subscriptionPeriod() {
      // First check if we have billingPeriod directly on the service (populated from vehicle-details.vue)
      if (this.service.billingPeriod) {
        // Check for 5-year products (Tablet Pack, Navigation Pack)
        if (
          (this.service.sku === 'DAF-Tab-Basic-001' ||
            this.service.sku === 'DAF-Tab-Nav-001' ||
            this.service.name === 'Tablet Package' ||
            this.service.name === 'Navigation Package') &&
          (this.service.billingPeriod === 'Specific Months' || this.service.billingPeriod === 'Specific_Months')
        ) {
          return '5 Years'
        }

        // Check for other periods
        switch (this.service.billingPeriod) {
          case 'Month':
            return 'Monthly'
          case 'Annual':
            return 'Annual'
          case 'Three Years':
          case 'Three_Years':
            return '3 Years'
          case 'Specific Months':
          case 'Specific_Months':
            return 'Multi-annual'
          default:
            return this.service.billingPeriod || ''
        }
      }

      // Fallback to rateplans structure if billingPeriod is not available
      if (!this.service.rateplans || this.service.rateplans.length === 0) {
        return ''
      }

      // Find the subscribed rate plan
      const subscribedRatePlan = this.service.rateplans.find(
        rp =>
          rp.ratePlanCharges &&
          rp.ratePlanCharges.some(charge => charge.subscribed === true)
      )

      if (!subscribedRatePlan || !subscribedRatePlan.ratePlanCharges) {
        return ''
      }

      const subscribedCharge = subscribedRatePlan.ratePlanCharges.find(
        charge => charge.subscribed === true
      )

      if (!subscribedCharge) {
        return ''
      }

      // Check for 5-year products (Tablet Pack, Navigation Pack)
      // Primary check by SKU and product name for 5-year products
      if (
        (this.service.sku === 'DAF-Tab-Basic-001' ||
          this.service.sku === 'DAF-Tab-Nav-001' ||
          this.service.name === 'Tablet Package' ||
          this.service.name === 'Navigation Package') &&
        (subscribedCharge.billingPeriod === 'Specific Months' || subscribedCharge.billingPeriod === 'Specific_Months')
      ) {
        return '5 Years'
      }

      // Fallback check by description if available
      if (
        (subscribedCharge.billingPeriod === 'Specific Months' || subscribedCharge.billingPeriod === 'Specific_Months') &&
        subscribedCharge.description &&
        subscribedCharge.description.includes('Five Year')
      ) {
        return '5 Years'
      }

      // Check for other periods
      switch (subscribedCharge.billingPeriod) {
        case 'Month':
          return 'Monthly'
        case 'Annual':
          return 'Annual'
        case 'Three Years':
        case 'Three_Years':
          return '3 Years'
        case 'Specific Months':
        case 'Specific_Months':
          // Try to determine duration from description or other fields
          if (subscribedCharge.description) {
            if (subscribedCharge.description.includes('Three Year')) {
              return '3 Years'
            }
            if (subscribedCharge.description.includes('Five Year')) {
              return '5 Years'
            }
          }
          return 'Multi-annual'
        default:
          return subscribedCharge.billingPeriod || ''
      }
    },
    /**
     * Get the correct expiration date based on endDateCondition
     */
    correctExpirationDate() {
      if (!this.service.rateplans || this.service.rateplans.length === 0) {
        return this.service.activeUntil
      }

      // Find the subscribed rate plan
      const subscribedRatePlan = this.service.rateplans.find(
        rp =>
          rp.ratePlanCharges &&
          rp.ratePlanCharges.some(charge => charge.subscribed === true)
      )

      if (!subscribedRatePlan || !subscribedRatePlan.ratePlanCharges) {
        return this.service.activeUntil
      }

      const subscribedCharge = subscribedRatePlan.ratePlanCharges.find(
        charge => charge.subscribed === true
      )

      if (!subscribedCharge) {
        return this.service.activeUntil
      }

      // For Fixed_Period products, use effectiveEndDate (LifeTimeEndDate equivalent)
      if (
        subscribedCharge.endDateCondition === 'Fixed_Period' &&
        subscribedCharge.effectiveEndDate
      ) {
        return subscribedCharge.effectiveEndDate
      }

      // For other products, use the standard activeUntil
      return this.service.activeUntil
    },
    /**
     * Check if this is a product that should show expiration date
     */
    shouldShowExpirationDate() {
      // Don't show expiration date for R&M products
      if (this.service.isRMProduct) {
        return false
      }

      // Don't show if explicitly hidden (HideFromEndDateDisplay__c)
      if (this.service.hideFromEndDateDisplay) {
        return false
      }

      // Don't show for monthly billing — no fixed end date
      if (this.service.billingPeriod === 'Monthly') {
        return false
      }

      // Only show for subscribed products
      return this.service.subscribed
    },
    /**
     * Format daysToExpire to show in days, months, or years based on duration
     */
    formattedTimeToExpire() {
      const days = this.service.daysToExpire

      if (days < 30) {
        // Show in days
        return {
          value: days,
          unit: days === 1 ? 'day' : 'days'
        }
      } else if (days < 365) {
        // Show in months (30 days = 1 month)
        const months = Math.round(days / 30)
        return {
          value: months,
          unit: months === 1 ? 'month' : 'months'
        }
      } else {
        // Show in years (365 days = 1 year)
        const years = Math.round(days / 365)
        return {
          value: years,
          unit: years === 1 ? 'year' : 'years'
        }
      }
    }
  },
  methods: {
    ...mapActions('notification', ['setSnackbar']),
    setPeriod(period) {
      this.$emit('period', period)
    },
    sendItems() {
      this.$emit('selected', this.selectedItems)
    },
    activateReadMore() {
      this.isDialogVisible = true
    },
    sendRemoveID(id) {
      this.$emit('remove', id)
    },
    handleStopService(service, vehicle) {
      // DAF-661 — backend contract (DetermineCanStop): stoppableByWebshopUser
      // 'Warning' keeps the stop button visible but the click must show a
      // warning instead of adding the stop to the basket.
      if (
        this.matchingActiveServiceRow?.stoppableByWebshopUser === 'Warning'
      ) {
        this.setSnackbar({
          showing: true,
          type: 'warning',
          text: this.$t(
            'vehicle_details.txt.notification_warning_stop_three_years'
          )
        })
        return
      }

      // rTDS: same as Service Details — rely on canStop only, skip base/add-on warnings
      if (service.isTachograph) {
        if (this.serviceCanStop) {
          this.sendRemoveID(service.prodId)
        } else {
          this.setSnackbar({
            showing: true,
            type: 'warning',
            text: this.$t('vehicle_details.txt.notification_warning_stop')
          })
        }
        return
      }

      // * Checks if the selected service has 'Three Years' as period
      const threeYears = service.rateplans.find(rateplan =>
        rateplan.ratePlanCharges.find(
          ratePlanCharge =>
            (ratePlanCharge.period === 'Three Years' || ratePlanCharge.period === 'Three_Years') && ratePlanCharge.subscribed
        )
      )

      // * Checks if the selected service has ten years as period
      const tenYears = ((service.type === 'Specific Months' || service.type === 'Specific_Months') && service.subscribed)
      // * If there's a 'Three Years' period on this service, show the warning message for three years
      if (threeYears) {
        this.setSnackbar({
          showing: true,
          type: 'warning',
          text: this.$t(
            'vehicle_details.txt.notification_warning_stop_three_years'
          )
        })
      }
      // * If there's a 'Lifetime 10 years' period on this service, show the warning message for three years
      else if (tenYears) {
        this.setSnackbar({
          showing: true,
          type: 'warning',
          text: this.$t(
            'vehicle_details.txt.notification_warning_stop_essentials_ten_years'
          )
        })
      }
      //TODO: Implement this logic when the backend is ready
      // Hardcoded logic blocked for now
      // If the backend returns canStop: true, the service can be stopped
      // The logic now respects only the canStop flag from activeServices

      // else if (service.sku === 'DAF-VHT-001') {
      //   this.setSnackbar({
      //     showing: true,
      //     type: 'warning',
      //     text: this.$t(
      //       'vehicle_details.txt.notification_warning_service_cant_stop'
      //     )
      //   })
      // }
      else if (service.isLifetime && vehicle.hasAddOnProduct) {
        // * If the service is a Base Product and there are add on products subscribed, show the warning message for base product
        this.setSnackbar({
          showing: true,
          type: 'warning',
          text: this.$t('vehicle_details.txt.notification_warning_stop_base')
        })
      } else if (service.isBaseProduct && vehicle.hasAddOnProduct) {
        // * check if mobile services has base product
        this.setSnackbar({
          showing: true,
          type: 'warning',
          text: this.$t(
            'vehicle_details.txt.notification_warning_addon_first_checkout'
          )
        })
      } else if (this.serviceCanStop) {
        this.sendRemoveID(service.prodId)
      } else {
        this.setSnackbar({
          showing: true,
          type: 'warning',
          text: this.$t('vehicle_details.txt.notification_warning_stop')
        })
      }
    },
    extendingUnsubscribable(period) {
      // DAF Connect exception: don't hide extension buttons based on rateplan flags
      // when < 60 days to expire (removal status should not matter).
      if (this.isDafConnectExtendAllowed) return false

      let billingPeriod
      if (period === 'month') billingPeriod = 'Month'
      if (period === 'annual') billingPeriod = 'Annual'
      // charge.subscribed is set for every rate plan of the product with an active
      // charge in that period; only the rate plan the vehicle is on has a ratePlanID (DAF-714).
      return (
        this.serviceStatus === 'Remove' &&
        !!this.service.rateplans.find(
          rp =>
            rp.isAllowedToSubscribe__c === 'False' &&
            !!rp.ratePlanID &&
            rp.ratePlanCharges.find(
              charge => charge.period === billingPeriod && charge.subscribed
            )
        )
      )
    }
  }
}
</script>

<style lang="scss">
.v-list-item--disabled {
  :first-child {
    color: var(--v-secondary-darken2);
  }
}
    .service-card {
        padding: 16px 16px 120px;
        vertical-align: bottom;
        border-radius: 6px !important;
        background-color: var(--v-pale-two-base) !important;
        height: 100%;
        vertical-align: bottom;

        @media screen and (max-width: 600px) {
            padding-bottom: 216px;
        }

        &.selected {
            background-color: var(--v-pale-four-base) !important;
        }

        &.subscribed {
            background-color: var(--v-light-base) !important;
        }

        &.disabled {
            opacity: 0.3;
        }

        &.renew {
            background-color: var(--v-oasis-base) !important;
        }

        &-header {
            h2 {
                font-size: 1rem;
                font-weight: bold;
                color: var(--v-slate-base);
            }

            .service-card-icon {
                float: left;
                margin-right: 10px;
            }

            .service-card-options-btn {
                position: absolute;
                top: 8px;
                right: 8px;
                width: 16px;
                height: 16px;
            }

            .service-card-options-menu {
                content: '';
                display: block;
                width: 0;
                height: 0;
                border-bottom: 12px solid transparent;
                border-left: 12px solid var(--v-darkgrey-blue-two-base);
                -webkit-transform: rotate(225deg);
                position: absolute;
                top: 28px;
                left: 45%;
            }
        }

        &-description {
            font-size: 0.875rem;
            color: var(--v-slate-base);
            clear: both;
            padding-top: 8px;
            padding-left: 4px;

            .subscription-period-badge {
                display: inline-block;
                border-radius: 12px;
                text-transform: capitalize;
            }
        }

        &-subscription {
            height: 100px;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 16px;
            display: flex;
            align-items: left;
            justify-content: left;
            text-align: left;

            span {
                font-size: 0.875rem;
                font-weight: bold;
                color: var(--v-slate-base);
            }

            @media screen and (max-width: 600px) {
                padding-bottom: 200px;
            }

            &-buttons.v-btn-toggle {
                display: block;
                margin-top: 4px;

                .v-btn {
                    border: solid 1px var(--v-cloudy-base) !important;
                    background-color: white !important;
                    font-size: 0.875rem;
                    color: var(--v-steel-base) !important;
                    text-transform: none;
                    min-width: 110px !important;
                    height: 32px;
                    border-radius: 4px;
                    margin: 4px;
                    font-weight: bold;
                    opacity: 1;
                    border-top-left-radius: 5px !important;
                    border-bottom-left-radius: 5px !important;
                    border-bottom-right-radius: 5px !important;
                    border-top-right-radius: 5px !important;

                    &.active {
                        background-color: var(--v-peacock-base) !important;

                        span {
                            color: white !important;
                        }
                    }

                    small {
                        font-size: 0.75rem;
                        font-weight: normal;
                    }
                }
            }

            .service-subscribed {
                span {
                    color: var(--v-peacock-base);
                }
            }

            .service-to-subscribe {
                align-items: left !important;
                text-align: left;
                justify-content: left;
                text-decoration: underline !important;

                &.enabled {
                    color: var(--v-peacock-base);
                }

                &.disabled {
                    color: var(--v-bluegrey-base);
                }
            }
        }

        &-longlived-subscribed {
            span {
                color: var(--v-peacock-base) !important;
            }
        }
    }
</style>
